export const FOOTER = {
  websiteUrl: 'https://jadhuhealth.com',
  footer: {
    brandDescription: "India's functional development platform building real-world independence for neurodivergent children and adults, two sessions a day, at home.",

    contact: {
      email: 'support@jadhuhealth.com',
      phone: '+91 63840 02876',
      phoneLink: 'tel:+916384002876',
      whatsapp: 'https://wa.me/916384002876',
      researchEmail: 'research@jadhuhealth.com'
    },

    social: {
      x: 'https://x.com/jadhuofficial',
      facebook: 'https://www.facebook.com/jadhuhealth',
      instagram: 'https://www.instagram.com/jadhuofficial/',
      linkedin: 'https://www.linkedin.com/company/jadhu/posts/?feedView=all',
    },

    donation: {
      milaap: '',
    },

    support: {
      hours: 'Mon–Sat, 9 AM – 7 PM',
    },

    company: {
      foundedBy: 'Vijay Karunakaran',
    },

    legal: {
      copyrightYear: 2026,
      sinceYear: 2025,
      privacy: 'Privacy Policy',
      terms: 'Terms',
      compliance: 'DPDP 2023 Compliant',
    },

    disclaimer: 'Jadhu does not replace clinical diagnosis or professional therapy.',
  }
}
